import styled from "styled-components";
import { space, borders } from "styled-system";
import { lighten, transparentize } from "polished";

import theme from "config/theme";

export const Wrapper = styled.div`
  width: calc(100% - 40px);
  margin: auto;
  max-width: ${theme.size.maxWidth};

  ${space};
  ${borders};
`;

export const Inner = styled.div`
  position: relative;
  overflow: hidden;
  text-align: center;
  min-height: 450px;
  border-radius: ${theme.radius};
  background-color: ${lighten(0.03, theme.color.gray)};
  box-shadow: 0 2px 25px ${transparentize(0.9, "black")};

  @media (max-width: ${theme.size.tablet}) {
    height: auto;
    min-height: 280px;
  }
`;

export const Videos = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  overflow: hidden;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-areas: "video1 video1 video2 video3" "video1 video1 video4 video4" ". . . .";

  & > a:nth-child(1) {
    grid-area: video1;
    height: 560px;
    border-right: 1px solid ${lighten(0.1, theme.color.gray)};

    h4 {
      @media (min-width: ${theme.size.tablet}) {
        font-size: ${theme.font.size.beta};
      }
    }

    @media (max-width: ${theme.size.tablet}) {
      display: block;
      border-right: none;
      height: 280px;
    }
  }

  & > a:nth-child(2) {
    grid-area: video2;
    height: 280px;
    border-right: 1px solid ${lighten(0.1, theme.color.gray)};

    @media (max-width: ${theme.size.tablet}) {
      border-right: none;
    }
  }

  & > a:nth-child(3) {
    grid-area: video3;
    height: 280px;
  }

  & > a:nth-child(4) {
    grid-area: video4;
    height: 280px;
    border-top: 1px solid ${lighten(0.1, theme.color.gray)};

    h4 {
      @media (min-width: ${theme.size.tablet}) {
        font-size: 26px;
      }
    }

    @media (max-width: ${theme.size.tablet}) {
      border-top: none;
    }
  }

  @media (max-width: ${theme.size.tablet}) {
    display: flex;
    flex-wrap: wrap;

    & > a {
      width: 100%;
      border: none;
      display: none;

      &:last-child {
        border-bottom: none;
      }
    }
  }
`;

export const Footer = styled.div`
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${theme.size.desktop}) {
    justify-content: center;
    border-bottom: none;
  }
`;

export const Tagline = styled.p`
  color: white;
  margin: 0 0 0 20px;
  line-height: 1.1;
  font-size: ${theme.font.size.theta};

  @media (max-width: ${theme.size.desktop}) {
    font-size: ${theme.font.size.upsilon};
  }
`;
